import { Typography } from '@mui/material'
import {
  FieldPath, FieldValues, UseFormRegister,
} from 'react-hook-form'
import ScanCodeInput from '../ScanCodeInput/ScanCodeInput'
import * as S from './ScanCode.styles'

interface ScanCodeProps<T extends FieldValues, K extends FieldPath<T>> {
  text?: string
  onSubmit: () => void
  register: UseFormRegister<T>;
  inputName: K;
  dataTestId: string;
  hasError?: boolean;
  errorMessage?: string
}

const ScanCode = <T extends FieldValues, K extends FieldPath<T>>(
  scanCodeProps: ScanCodeProps<T, K>,
) => {
  const {
    text, inputName, hasError, errorMessage, dataTestId, register, onSubmit,
  } = scanCodeProps
  return (
    <S.Container>
      { text && <Typography>{text}</Typography> }
      <ScanCodeInput
        onSubmit={onSubmit}
        register={register}
        dataTestId={dataTestId}
        inputName={inputName}
        hasError={hasError}
        errorMessage={errorMessage}
      />
    </S.Container>
  )
}

export default ScanCode
